import React, { useEffect, useState } from 'react';
import SectionTitle from '../../components/Common/SectionTitle';
import SingleServiceFlip from '../../components/Service/SingleServiceFlip';
import shapeImg from '../../assets/img/service/s2.png';

const ServiceFlip = () => {
    const [services, setServices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [mainTitle, setMainTitle] = useState('');

    useEffect(() => {
        // Fetch services from API
        const fetchServices = async () => {
            try {
                const response = await fetch('https://yautiktechnology.com/api/services');
                if (!response.ok) {
                    throw new Error('Failed to fetch services');
                }
                const data = await response.json();

                // Extract main title and services
                const mainServiceTitle = data.find(service => service.title)?.title || '';
                setMainTitle(mainServiceTitle);
                setServices(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchServices();
    }, []);

    return (
        <div id="rs-service" className="rs-services main-home style2 pt-120 pb-94 md-pt-80 md-pb-60">
            <div className="container">
                <SectionTitle
                    sectionClass="sec-title2 text-center mb-46"
                    subtitleClass="sub-text style-bg"
                    subtitle="Services"
                    titleClass="title"
                    title={mainTitle}
                />
                {loading ? (
                    <p>Loading services...</p>
                ) : error ? (
                    <p>Error: {error}</p>
                ) : (
                    <div className="row">
                        {services.map(service => (
                            <div className="col-lg-4 col-md-6 mb-26" key={service.id}>
                                <SingleServiceFlip
                                    itemClass="flip-box-inner"
                                    serviceImage={service.imageUrl}
                                    serviceURL={`/${service.productTitle.toLowerCase().replace(/ /g, '-')}`}
                                    Title1={service.productTitle}
                                    TextDesc={service.description}
                                    ButtonClass1="readon view-more"
                                    ButtonText1="Read More"
                                />
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <div className="shape-animation">
                <div className="shape-part">
                    <img className="dance" src={shapeImg} alt="shape animation" />
                </div>
            </div>
        </div>
    );
};

export default ServiceFlip;
